import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { metricsAtom } from '@/atoms/metric';
import { radarTemplateCurrentMetricAtom } from '@/atoms/radar';
import { SortableListItem } from '@/components/listItem/SortableListItem';
import { MIN_SELECTED_METRICS } from '@/consts/radar';
import { useCurrentFormattedMinMaxMetricValues } from '@/hooks/useCurrentFormattedMinMaxMetricValues';
import { getTranslationMetrics } from '@/utils/translations';

export const MetricLimitsAsideContent = () => {
  const { t } = useTranslation(['modal']);
  const selectedMetrics = useAtomValue(metricsAtom);
  const [activeMetric, setActiveMetric] = useAtom(radarTemplateCurrentMetricAtom);
  const getCurrentFormattedMinMaxMetricValues = useCurrentFormattedMinMaxMetricValues();
  const numberOfSpokes = Math.max(selectedMetrics.length, MIN_SELECTED_METRICS);

  const handleMetricClick = (metric: string) => {
    if (activeMetric !== metric) {
      setActiveMetric(metric);
    }
  };

  return (
    <ol className="flex flex-col gap-2 pb-4 overflow-hidden">
      {selectedMetrics.map((metric, index) => {
        const label = t(`${getTranslationMetrics(metric)}.name`, { ns: 'metrics' });
        const { min, max } = getCurrentFormattedMinMaxMetricValues(metric);

        return (
          <SortableListItem
            id={metric}
            key={metric}
            onClick={() => handleMetricClick(metric)}
            numberOfSpokes={numberOfSpokes}
            ariaLabel={label}
            spokeIndex={index}
            isActive={activeMetric === metric}
          >
            <span className="flex-1 truncate" title={label}>
              {label}
            </span>
            <span className="pl-2">
              {min} - {max}
            </span>
          </SortableListItem>
        );
      })}
    </ol>
  );
};
